<template>
    <v-container>
      <v-card>
        <v-card-title>
          <span class="text-h6">Permisos</span>
          <v-spacer></v-spacer>
          <v-btn small color="primary" @click="openDialog('add')"
            ><v-icon>mdi-plus</v-icon></v-btn
          >
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="permissions"
          item-value="id"
          dense
          :search="search"
          class="elevation-1"
        >
          <template v-slot:top>
            <v-text-field
              v-model="search"
              label="Buscar"
              outlined
              dense
              class="mx-4"
            ></v-text-field>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-btn icon @click="openDialog('edit', item)">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
            <!--v-btn icon color="red" @click="deletepermission(item.id)">
              <v-icon>mdi-delete</v-icon-->
            </v-btn>
          </template>
        </v-data-table>
      </v-card>
  
      <!-- Diálogo para agregar/editar -->
      <v-dialog v-model="dialog" max-width="500px">
        <v-card>
          <v-card-title>{{ dialogTitle }}</v-card-title>
          <v-card-text>
            <v-form ref="form">
              <v-text-field
                v-model="permission.name"
                label="Nombre"
                outlined
                dense
                required
              ></v-text-field>
              <v-text-field
                v-model="permission.description"
                label="Descripción"
                outlined
                dense
                required
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="dialog = false">Cancelar</v-btn>
            <v-btn color="primary" @click="savePermission">Guardar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-overlay :value="overlay" :z-index="3000">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    </v-container>
  </template>
    
    <script>
  import axios from "@/plugins/axios.js";
  export default {
    data() {
      return {
        search: "",
        dialog: false,
        dialogTitle: "",
        headers: [
        { text: "#", value: "id" },
        { text: "Nombre", value: "name" },
        { text: "Descripción", value: "description" },
        { text: "Acciones", value: "actions", sortable: false },
        ],
        permissions: [], // Aquí se cargan los datos de usuarios desde la API
        permission: { id: null, name: "", description: null },
        action: "", // 'add' o 'edit'
        overlay: false,
      };
    },
    mounted() {
      this.getPermissions();
    },
    methods: {
      getPermissions() {
        this.overlay = true;
        axios
          .get("/admin/getPermissions")
          .then((response) => {
            this.permissions = [...response.data];
            this.overlay = false;
          })
          .catch((err) => {
            this.overlay = false;
            //this.msjModal = "Error! " + err;
            //this.$refs["msj-modal"].show();
          });
      },
      openDialog(action, permission = null) {
        this.action = action;
      this.clearForm();
      if(this.action === 'edit'){
        this.permission = {
          id: permission.id,
          name: permission.name,
          description: permission.description,
        };
      }
      this.dialogTitle =
        action === "add" ? "Agregar Permiso" : "Editar Permiso";
      this.dialog = true;
      },
      savePermission() {
        if (this.action === "add") {
        this.createPermission();
      } else {
        this.updatePermission();
      }
      this.dialog = false;
      },
      createPermission() {
      this.overlay = true;
      axios
        .post("/admin/createPermissions", {
          // Aquí debes enviar los datos del formulario
          name: this.permission.name,
          description: this.permission.description,
        })
        .then((response) => {
          this.getPermissions();
          this.modalVisible = false;
          this.overlay = false;
          this.clearForm();
        })
        .catch((err) => {
          this.overlay = false;
          //this.msjModal = "Error! " + err;
          //this.$refs["msj-modal"].show();
        });
    },
    updatePermission() {
      this.overlay = true;
      axios
        .post("/admin/update", {
          // Aquí debes enviar los datos del formulario
          id: this.permission.id,
          name: this.permission.name,
          description: this.permission.description,
          //password: this.user.password,
        })
        .then((response) => {
          this.getRoles();
          this.modalVisible = false;
          this.overlay = false;
          this.clearForm();
        })
        .catch((err) => {
          this.overlay = false;
          //this.msjModal = "Error! " + err;
          //this.$refs["msj-modal"].show();
        });
    },
    clearForm() {
      this.permission = {
        id: null,
        name: "",
        description: null,
      };
      this.isEdit = false;
    },
      deletepermission(id) {
        // Simulación de eliminación
        this.permissions = this.permissions.filter((u) => u.id !== id);
      },
    },
  };
  </script>
    